import React, { useEffect } from "react";
import ContactUsHeroSection from "../components/contactUs/ContactUsHeroSection";
import ContactUsFormDetails from "../components/contactUs/ContactUsForm&Details";
import CtaArea from "../components/CtaArea";

const ContactUs = () =>{
    useEffect(() => {
        const hero = document.querySelector('.common-hero');
        if (hero) {
          hero.scrollIntoView({ behavior: 'smooth' });
        }
      }, []);
    return(
        <>
            <ContactUsHeroSection/>
            {/* <AboutUsBanner/> */}
            <ContactUsFormDetails/>
            <CtaArea/>
        </>
    )
}

export default ContactUs;